import * as React from "react";
import styled from "styled-components";

const Styling = styled.svg`
  .st0 {
    fill: #ffffff;
  }
  .st1 {
    filter: url(#Adobe_OpacityMaskFilter);
  }
  .st2 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #ffffff;
  }
  .st3 {
    mask: url(#mask-2_1_);
  }
  .st4 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #dcdcdc;
  }
  .st5 {
    fill: none;
    stroke: #bfbfbf;
    stroke-width: 3;
  }
  .st6 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #e9e9e9;
  }
  .st7 {
    fill: none;
    stroke: #ffffff;
    stroke-width: 9;
  }
  .st8 {
    fill: none;
    stroke: #ffffff;
    stroke-width: 19;
  }
  .st9 {
    fill: none;
    stroke: #dcdcdc;
    stroke-width: 3;
  }
  .st10 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #cecece;
  }
  .st11 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #969696;
  }
  .st12 {
    fill: none;
    stroke: #969696;
    stroke-width: 2;
  }
  .st13 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #b2b2b2;
  }
  .st14 {
    fill: none;
    stroke: #b2b2b2;
    stroke-width: 2;
  }
  .st15 {
    fill: none;
    stroke: #ffffff;
    stroke-width: 7;
  }
  .st16 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #a3a3a3;
  }
  .st17 {
    fill: none;
    stroke: #a3a3a3;
    stroke-width: 2;
  }
  .st18 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #888888;
  }
  .st19 {
    opacity: 0.6027;
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #ffffff;
    enable-background: new;
  }
  .st20 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: url(#left-mask_1_);
  }
  .st21 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: url(#right-mask_1_);
  }
  .st22 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: url(#bottom-mask_1_);
  }
  .st23 {
    fill: #fffcf7;
  }
  .st24 {
    fill: #ffdea5;
  }
  .st25 {
    fill: #fe964b;
  }
  .st26 {
    fill: #ffcc74;
  }
  .st27 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #fecda9;
  }
  .st28 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #feae73;
  }
  .st29 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: url(#top-mask_1_);
  }
  .st30 {
    opacity: 0.8508;
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #e7e7e7;
    enable-background: new;
  }
  .st31 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #3c3c3c;
  }
  .st32 {
    opacity: 0.8176;
  }
  .st33 {
    fill: #ffd07c;
    fill-opacity: 0.97;
  }
  .st34 {
    fill: #a5a5a5;
  }
  .st35 {
    fill: #dcdcdc;
  }
  .st36 {
    fill: #ffc7c8;
  }
  .st37 {
    fill: #ff575b;
  }
  .st38 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #8a9c3c;
  }
`;

export const ProspectSvg = () => (
  <Styling viewBox="0 0 1770 1770">
    <g>
      <polygon className="st0" points="0.4 1.2 1770 5.1 1770 1770 0 1765.4" />
      <g transform="translate(-174 -180)">
        <defs>
          <filter
            id="f"
            x="171.7"
            y="185.1"
            width="1915.7"
            height="1752"
            filterUnits="userSpaceOnUse"
          >
            <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
          </filter>
        </defs>
        <mask
          id="c"
          x="171.7"
          y="185.1"
          width="1915.7"
          height="1752"
          maskUnits="userSpaceOnUse"
        >
          <g className="st1">
            <polygon
              className="st2"
              points="3.7 0 2299 0 2299 1937.4 3.7 1937.4"
            />
          </g>
        </mask>
        <g className="st3">
          <g transform="translate(3.6562)">
            <polygon
              className="st4"
              points="168 1937.1 1979.9 1937.1 1979.9 1217.5 168 1217.5"
            />
            <polygon
              className="st2"
              points="169 1217.9 1939.9 1217.9 1939.9 1179.1 169 1179.1"
            />
            <polygon
              className="st2"
              points="170.4 868.4 627.4 868.4 627.4 536.6 170.4 536.6"
            />
            <polygon
              className="st5"
              points="170.4 868.4 627.4 868.4 627.4 536.6 170.4 536.6"
            />
            <polygon
              className="st6"
              points="230.2 808.2 561.7 808.2 561.7 596.8 230.2 596.8"
            />
            <path className="st7" d="m276.3 835.9 194.8-262.6" />
            <path className="st8" d="m373.7 835.9 194.8-262.6" />
            <polygon
              className="st6"
              points="1622.1 1176.3 2034.7 1176.3 2034.7 222.7 1622.1 222.7"
            />
            <path
              className="st2"
              d="m1926.6 421.1c0 72.5-58.9 131.3-131.6 131.3s-131.6-58.8-131.6-131.3 58.9-131.3 131.6-131.3 131.6 58.8 131.6 131.3"
            />
            <path className="st9" d="m1598 712.2h459.2" />
            <path className="st9" d="m1753.7 228.7v947.6" />
            <path className="st9" d="m1911 228.7v947.6" />
            <path className="st9" d="m1598 403.2h459.2" />
            <path className="st9" d="m1624.5 994.7h459.2" />
            <polygon
              className="st10"
              points="1511.3 1217.7 1622.1 1217.7 1622.1 228.7 1511.3 228.7"
            />
            <polygon
              className="st4"
              points="1541.8 1217.7 1554.2 1217.7 1554.2 228.7 1541.8 228.7"
            />
            <polygon
              className="st4"
              points="1573.3 1217.7 1598 1217.7 1598 228.7 1573.3 228.7"
            />
            <polygon
              className="st2"
              points="1480.8 228.7 1940.3 228.7 1940.3 185.1 1480.8 185.1"
            />
            <g transform="translate(1666.4 809.28)">
              <path
                className="st11"
                d="m156.1 163.1 31.7-17.4c2.6-8.9 8.8-20.7 10.5-30.8l-32.4 4.1 34-16.1c1.3-11.6 1.5-33.2 1.5-33.2l-21.6 2.8 20.6-17.1s-3.1-26.2-6.2-34.5l-15.4 7.5 3.5-21.5c-3.2-3.1-6.7-5.1-10.6-6-1.2-0.3-2.5-0.4-3.7-0.5-1.7 20.7-4.3 28.7-4.3 28.7l-4.2-27.1c-4.4 1.7-8.8 4.9-13.1 9.2l3.6 49.3-12-39c-5.9 8.5-11.3 19.3-15.8 31.7l16.6 43.1-22.8-28.8c-1.5 6.2-8.9 30.5-7.2 52.2l19 19.5-20.1-5.8c22.1 32.3 16.4 79 25.6 63.3 8.8-15 23.7-23.9 51-33.7l-28.2 0.1z"
              />
              <path className="st12" d="m154.6 412.9s-26.9-131.4-22.2-236.9" />
              <path
                className="st13"
                d="m66.1 245.3-40.1-21.8c-3.8-10.1-7.3-20.8-10.3-32.2l37.2 14.1-40.4-27.6c-2.8-13-4.5-25.6-5.4-37.3 11.2 8.2 28.7 22.2 27.5 21.1-5.2-6.5-17.7-23.2-28.1-37.2 0-12.6 0.2-29.5 2.5-38.9l27.7 49.2s-10.5-40.8-16.7-65c3-3.5 6.5-5.8 10.5-6.8 1.3-0.3 2.6-0.5 3.9-0.5 4.2 23.2 12.6 46.6 12.6 46.6l-3.3-44.9c4.9 1.9 9.9 5.4 15 10.3l1.9 55.5 8.2-44c7.2 9.5 14.2 21.6 20.4 35.6l-5.7 45.1 13.9-29.1c2.3 6.9 13 34.3 13.7 58.7l-10.4 30.8 13.1-15.4c-14 54.1-8.1 89-19.7 71.3-11.1-16.9-27.8-26.8-58-37.7l30 0.1z"
              />
              <path
                className="st14"
                d="m93.4 269.5s3.3 33.2 24.9 76.3 36.8 126.5 36.4 141.3"
              />
              <path
                className="st11"
                d="m0.4 266.5s88.3 25.4 134.5 136.4l-0.1 26.5s0.3-20.4-45.6-60.1c-45.9-39.6-80.6-68.1-88.8-102.8"
              />
              <path
                className="st13"
                d="m246.6 262.4c6.6-3.1-4.3 32.4-28.5 68.5-24.3 36.1-30.6 90.1-30.6 90.1s-12.1-125.2 59.1-158.6"
              />
              <path
                className="st13"
                d="m102.9 268.8c-6.6-3.1 4.3 32.4 28.5 68.5 24.3 36.1 30.6 90.1 30.6 90.1s12.2-125.2-59.1-158.6"
              />
              <path
                className="st11"
                d="m185.6 405.7c2.3 5 22-139.9-18.2-222.7 0.1 0-23.3 134.8 18.2 222.7"
              />
              <path
                className="st13"
                d="m226 233.3 36.3-15.4c4.2-8.3 8-17.3 11.5-26.8l-33.1 9 37-20.3c3.5-10.9 6-21.6 7.8-31.6-10.3 6.1-26.5 16.7-25.3 15.8 5-5.2 17.1-18.5 27.2-29.6 1.1-10.8 2.3-25.4 1.1-33.6l-27.9 40s12.4-34.2 19.8-54.4c-2.3-3.2-5.1-5.5-8.4-6.7-1.1-0.4-2.2-0.6-3.3-0.8-5.6 19.6-14.7 39-14.7 39l6.6-38.3c-4.4 1.3-9 3.8-13.7 7.6l-6.3 47.5-3.3-38.4c-7 7.6-14 17.4-20.5 28.8l1.1 39.2-9.5-26.2c-2.6 5.8-14.1 28.3-16.7 49.3l6.4 27.3-10-14.3c7.5 47.6-0.4 77.1 11 62.9 10.9-13.6 26.2-20.7 53-27.5l-26.1-2.5z"
              />
              <path
                className="st14"
                d="m199.1 251.8s-20.5 88.9-22.3 152c-0.5 15.7 0.2 29.7 2.7 40.5"
              />
              <path
                className="st2"
                d="m159.2 516.4c90.9 0 83.7-158.6 83.7-158.6h-197.9s-7.1 158.6 83.7 158.6h30.5z"
              />
            </g>
            <polygon
              className="st11"
              points="709.9 1334.5 716.8 1334.5 716.8 1246.6 709.9 1246.6"
            />
            <polygon
              className="st11"
              points="724.7 1334.5 731.7 1334.5 731.7 1246.6 724.7 1246.6"
            />
            <polygon
              className="st11"
              points="1500.7 1334.5 1507.6 1334.5 1507.6 1246.6 1500.7 1246.6"
            />
            <polygon
              className="st11"
              points="1515.5 1334.5 1522.5 1334.5 1522.5 1246.6 1515.5 1246.6"
            />
            <polygon
              className="st6"
              points="679.6 1246.6 1554.2 1246.6 1554.2 1067.7 679.6 1067.7"
            />
            <polygon
              className="st6"
              points="1116.9 1240.7 1554.2 1240.7 1554.2 1073.6 1116.9 1073.6"
            />
            <polygon
              className="st15"
              points="679.6 1246.6 1554.2 1246.6 1554.2 1067.7 679.6 1067.7"
            />
            <path
              className="st10"
              d="m725.7 1157.1c0 4.9-4 8.9-8.9 8.9s-8.9-4-8.9-8.9 4-8.9 8.9-8.9c4.9 0.1 8.9 4 8.9 8.9"
            />
            <path
              className="st10"
              d="m1529.4 1157.1c0 4.9-4 8.9-8.9 8.9s-8.9-4-8.9-8.9 4-8.9 8.9-8.9c4.9 0.1 8.9 4 8.9 8.9"
            />
            <polygon
              className="st11"
              points="976.2 1054.6 1130.3 1054.6 1130.3 1031.2 976.2 1031.2"
            />
            <polygon
              className="st13"
              points="986.6 1031.2 1119.9 1031.2 1119.9 1011.9 986.6 1011.9"
            />
            <path
              className="st16"
              d="m875.9 1055.9h-11.2c-10.6 0-19.3-8.6-19.3-19.2v-30.1h49.8v30.1c0 10.5-8.7 19.2-19.3 19.2"
            />
            <path
              className="st17"
              d="m907.2 1024c0 6.2-5 11.2-11.2 11.2s-11.2-5-11.2-11.2 5-11.2 11.2-11.2 11.2 5 11.2 11.2z"
            />
            <path
              className="st2"
              d="m1343.5 511.3h-540.4c-12.4 0-22.5-10.1-22.5-22.4v-148.6c0-12.3 10.1-22.4 22.5-22.4h540.4c12.4 0 22.5 10.1 22.5 22.4v148.6c0 12.3-10.1 22.4-22.5 22.4"
            />
            <path
              className="st10"
              d="m1349.2 511.3h-551.8c-9.2 0-16.8-7.5-16.8-16.7v-44.2h585.4v44.2c0 9.2-7.6 16.7-16.8 16.7"
            />
            <path
              className="st11"
              d="m1341.6 490.2h-536.6c-3.5 0-6.4-2.9-6.4-6.4v-13c0-3.5 2.9-6.4 6.4-6.4h536.6c3.5 0 6.4 2.9 6.4 6.4v13c0 3.5-2.9 6.4-6.4 6.4"
            />
            <path
              className="st4"
              d="m1341.6 476.1h-536.6c-1.8 0-3.2-1.4-3.2-3.2v-3.1c0-1.8 1.4-3.2 3.2-3.2h536.6c1.8 0 3.2 1.4 3.2 3.2v3.1c0 1.7-1.5 3.2-3.2 3.2"
            />
            <path
              className="st4"
              d="m1341.6 488h-536.6c-1.8 0-3.2-1.4-3.2-3.2v-3.1c0-1.8 1.4-3.2 3.2-3.2h536.6c1.8 0 3.2 1.4 3.2 3.2v3.1c0 1.8-1.5 3.2-3.2 3.2"
            />
            <path
              className="st6"
              d="m1073.3 317.9h-242.8s14.7 6.8 41.5 26.7c18.1 13.5 38.6 17.5 63 17.5h276.6c24.4 0 44.9-4 63-17.5 26.8-19.9 41.5-26.7 41.5-26.7h-242.8z"
            />
            <path
              className="st2"
              d="m1073.3 311.5h-242.8s14.7 6.8 41.5 26.7c18.1 13.5 38.6 17.5 63 17.5h276.6c24.4 0 44.9-4 63-17.5 26.8-19.9 41.5-26.7 41.5-26.7h-242.8z"
            />
            <path
              className="st18"
              d="m1315.8 327.4h33.5c1.4 0 2.5 1.1 2.5 2.5v11c0 1.4-1.1 2.5-2.5 2.5h-33.5c-1.4 0-2.5-1.1-2.5-2.5v-11c0-1.4 1.1-2.5 2.5-2.5z"
            />
          </g>
        </g>
        <polygon
          className="st19"
          points="180.7 180 1967 180 1967 1937.4 180.7 1937.4"
        />
        <linearGradient
          id="d"
          x1="761.76"
          x2="761.76"
          y1="1483.4"
          y2="1483.1"
          gradientTransform="matrix(-1.0822e-13 -1767.4 519.72 -3.1824e-14 -770577 1347412)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" offset="0" />
          <stop stopColor="#FFFFFE" stopOpacity=".9188" offset=".505" />
          <stop stopColor="#FFFFFE" offset="1" />
        </linearGradient>
        <polygon
          className="st20"
          points="443.7 1945.4 443.7 178 174 178 174 1945.4"
        />
        <linearGradient
          id="b"
          x1="761.76"
          x2="761.76"
          y1="1485.8"
          y2="1485.2"
          gradientTransform="matrix(1.0761e-13 -1757.4 -515.72 -3.1579e-14 767982 1339804)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" offset="0" />
          <stop stopColor="#FFFFFE" stopOpacity=".9188" offset=".505" />
          <stop stopColor="#FFFFFE" offset="1" />
        </linearGradient>
        <polygon
          className="st21"
          points="1609 1952.3 1609 180 1967 180 2124.7 180 2124.7 1952.3"
        />
        <linearGradient
          id="e"
          x1="761.17"
          x2="761.17"
          y1="1486.1"
          y2="1485.5"
          gradientTransform="matrix(1793.3 0 0 -323.29 -1363974 482179)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" offset="0" />
          <stop stopColor="#fff" stopOpacity=".8015" offset=".5567" />
          <stop stopColor="#FFFFFE" offset="1" />
        </linearGradient>
        <polygon
          className="st22"
          points="174 1662 1945.3 1662 1945.3 1952.3 174 1952.3"
        />
      </g>
      <rect className="st0" x="189" y="226" width="1080" height="1476" />
      <g transform="translate(189 226)">
        <rect className="st23" width="1080" height="1476.3" />
        <g transform="translate(126 184)">
          <g transform="translate(0 974)">
            <rect className="st24" width="297.2" height="17.4" />
            <rect className="st24" y="26" width="819.4" height="17.4" />
            <rect className="st24" y="52" width="829.8" height="17.4" />
            <rect className="st24" y="77" width="829.8" height="17.4" />
            <rect className="st24" y="102" width="808.9" height="17.4" />
            <rect className="st24" y="128" width="675.5" height="17.4" />
          </g>
          <rect className="st24" width="158.6" height="17.4" />
          <rect className="st24" y="153" width="158.6" height="17.4" />
          <rect className="st24" y="205" width="158.6" height="17.4" />
          <rect className="st24" y="179" width="285" height="17.4" />
          <g transform="translate(6 70)">
            <rect className="st24" y="12" width="8" height="12" />
            <rect className="st24" x="24" y="12" width="8" height="12" />
            <rect className="st24" x="48" y="12" width="8" height="12" />
            <rect className="st24" x="60" y="12" width="8" height="12" />
            <rect className="st24" x="108" y="12" width="8" height="12" />
            <rect className="st24" x="156" y="12" width="8" height="12" />
            <rect className="st24" x="84" y="12" width="8" height="12" />
            <rect className="st24" x="132" y="12" width="8" height="12" />
            <rect className="st24" x="12" y="12" width="8" height="24" />
            <rect className="st24" x="36" y="12" width="8" height="24" />
            <rect className="st24" x="72" width="8" height="24" />
            <rect className="st24" x="120" width="8" height="24" />
            <rect className="st24" x="168" width="8" height="24" />
            <rect className="st24" x="96" width="8" height="24" />
            <rect className="st24" x="144" y="12" width="8" height="24" />
          </g>
        </g>
        <g transform="translate(125.52 498.16)">
          <rect className="st24" width="255.4" height="17.4" />
          <rect className="st24" y="224.3" width="255.4" height="17.4" />
          <polygon className="st24" points="17.4 0 17.4 241.7 0 241.7 0 0" />
          <polygon
            className="st24"
            points="255.4 0 255.4 241.7 238 241.7 238 0"
          />
        </g>
        <g transform="translate(415.79 498.16)">
          <rect className="st24" width="255.4" height="17.4" />
          <rect className="st24" y="224.3" width="255.4" height="17.4" />
          <polygon className="st24" points="17.4 0 17.4 241.7 0 241.7 0 0" />
          <polygon
            className="st24"
            points="255.4 0 255.4 241.7 238 241.7 238 0"
          />
        </g>
        <g transform="translate(706.05 498.16)">
          <rect className="st25" width="255.4" height="17.4" />
          <rect className="st25" y="224.3" width="255.4" height="17.4" />
          <polygon className="st25" points="17.4 0 17.4 241.7 0 241.7 0 0" />
          <polygon
            className="st25"
            points="255.4 0 255.4 241.7 238 241.7 238 0"
          />
        </g>
        <g transform="translate(125.52 774.67)">
          <rect className="st24" width="255.4" height="17.4" />
          <rect className="st24" y="224.3" width="255.4" height="17.4" />
          <polygon className="st24" points="17.4 0 17.4 241.7 0 241.7 0 0" />
          <polygon
            className="st24"
            points="255.4 0 255.4 241.7 238 241.7 238 0"
          />
        </g>
        <g transform="translate(415 774)">
          <polygon
            className="st24"
            points="18.2 0.7 18.2 242.4 0.8 242.4 0.8 0.7"
          />
          <rect className="st24" x="1.7" y=".7" width="544.8" height="17.4" />
          <rect className="st24" x="1.7" y="225" width="544.8" height="17.4" />
          <polygon
            className="st26"
            points="546.5 0.7 546.5 242.4 529 242.4 529 0.7"
          />
        </g>
        <ellipse className="st24" cx="940.5" cy="130" rx="69.5" ry="69" />
      </g>
      <g transform="translate(11.5 1687) scale(-1 1) translate(-294.5 -376)">
        <path
          className="st27"
          d="M19,6.2C-15.8,24.8,7.8,74.5,7.8,74.5s24.9,41,49.7,70.8c24.9,29.8,33.6,69.6,37.3,100s1.2,141,31.1,194.3    c4.1,7.4,13.8,21.7,13.8,21.7l166.3-6.9c0,0,2.3-63.1,1.3-123.7c-3.5-10.6-6.5-20.8-8.5-30.2c-14.9-68.3-27.4-142.8-43.5-172    C239.1,99.3,114.7,0,114.7,0v84.4C103.6,74.5,39-5.7,19,6.2z"
        />
        <path
          className="st28"
          d="m115 84.5c0.1 0 32.6 48.1 40.7 63.8 21 40.9 60.1 99.6 67.3 106.5 0 0-40.8-70.3-51-95.2-5.7-13.8-49.8-83.4-57.1-83v7.9z"
        />
      </g>
      <linearGradient
        id="a"
        x1="587.17"
        x2="587.17"
        y1="1303.6"
        y2="1303"
        gradientTransform="matrix(1793 0 0 360 -1051904 -469017)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0" offset="0" />
        <stop stopColor="#fff" stopOpacity=".8015" offset=".5567" />
        <stop stopColor="#FFFFFE" offset="1" />
      </linearGradient>
      <polygon className="st29" points="0 362.1 1770 362.1 1770 2.1 0 2.1" />
      <g transform="translate(855 507)">
        <path
          className="st30"
          d="m419.2 1068.3h-335.4c-46.1 0-83.8-28.3-83.8-62.8v-919.7c0-34.5 37.7-62.8 83.8-62.8h335.3c46.1 0 83.8 28.3 83.8 62.8v919.6c0.1 34.6-37.6 62.9-83.7 62.9"
        />
        <path
          className="st31"
          d="m468.6 1046.2h-353.4c-48.6 0-88.3-28.3-88.3-62.8v-919.6c0-34.5 39.7-62.8 88.3-62.8h353.3c48.6 0 88.3 28.3 88.3 62.8v919.6c0.1 34.6-39.7 62.8-88.2 62.8"
        />
        <g transform="translate(26.889 37.629)">
          <path
            className="st0"
            d="m29 28h473c4.4 0 8 3.6 8 8v896c0 4.4-3.6 8-8 8h-473c-4.4 0-8-3.6-8-8v-896c0-4.4 3.6-8 8-8z"
          />
          <g className="st32" transform="translate(40 53)">
            <path
              className="st33"
              d="M11.5,23C5.1,23,0,17.9,0,11.5S5.1,0,11.5,0S23,5.1,23,11.5S17.9,23,11.5,23z       M11.5,17c3,0,5.5-2.5,5.5-5.5S14.5,6,11.5,6S6,8.5,6,11.5S8.5,17,11.5,17z"
            />
            <path
              className="st33"
              d="M11.5,58C5.1,58,0,52.9,0,46.5S5.1,35,11.5,35S23,40.1,23,46.5      S17.9,58,11.5,58z M11.5,52c3,0,5.5-2.5,5.5-5.5S14.5,41,11.5,41S6,43.5,6,46.5S8.5,52,11.5,52z"
            />
            <path
              className="st33"
              d="M11.5,93C5.1,93,0,87.9,0,81.5S5.1,70,11.5,70S23,75.1,23,81.5      S17.9,93,11.5,93z M11.5,87c3,0,5.5-2.5,5.5-5.5S14.5,76,11.5,76S6,78.5,6,81.5S8.5,87,11.5,87z"
            />
            <path
              className="st33"
              d="m11.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m11.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m11.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m323.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m167.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="M89.5,23C83.1,23,78,17.9,78,11.5S83.1,0,89.5,0S101,5.1,101,11.5      S95.9,23,89.5,23z M89.5,17c3,0,5.5-2.5,5.5-5.5S92.5,6,89.5,6S84,8.5,84,11.5S86.5,17,89.5,17z"
            />
            <path
              className="st33"
              d="m89.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m89.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m89.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m89.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m89.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m401.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m245.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="M50.5,23C44.1,23,39,17.9,39,11.5S44.1,0,50.5,0S62,5.1,62,11.5S56.9,23,50.5,23      z M50.5,17c3,0,5.5-2.5,5.5-5.5S53.5,6,50.5,6S45,8.5,45,11.5S47.5,17,50.5,17z"
            />
            <path
              className="st33"
              d="M50.5,58C44.1,58,39,52.9,39,46.5S44.1,35,50.5,35S62,40.1,62,46.5      S56.9,58,50.5,58z M50.5,52c3,0,5.5-2.5,5.5-5.5S53.5,41,50.5,41S45,43.5,45,46.5S47.5,52,50.5,52z"
            />
            <path
              className="st33"
              d="M50.5,93C44.1,93,39,87.9,39,81.5S44.1,70,50.5,70S62,75.1,62,81.5      S56.9,93,50.5,93z M50.5,87c3,0,5.5-2.5,5.5-5.5S53.5,76,50.5,76S45,78.5,45,81.5S47.5,87,50.5,87z"
            />
            <path
              className="st33"
              d="m50.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m50.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m50.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m362.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m206.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m128.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m440.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 23c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 58c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 93c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 128c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 163c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
            <path
              className="st33"
              d="m284.5 198c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5 11.5 5.1 11.5 11.5-5.1 11.5-11.5 11.5zm0-6c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z"
            />
          </g>
          <polygon
            className="st34"
            points="57 176 477.9 176 477.9 192 57 192"
          />
          <polygon
            className="st35"
            points="57 419 210.9 419 210.9 352.2 57 352.2"
          />
          <polygon
            className="st34"
            points="57 465 233.9 465 233.9 482 57 482"
          />
          <polygon
            className="st34"
            points="57 513.6 435.9 513.6 435.9 524.6 57 524.6"
          />
          <polygon
            className="st34"
            points="57 567.6 435.9 567.6 435.9 578.6 57 578.6"
          />
          <polygon
            className="st34"
            points="57 540.6 413.6 540.6 413.6 551.6 57 551.6"
          />
          <polygon
            className="st34"
            points="57 594.6 413.6 594.6 413.6 605.6 57 605.6"
          />
          <polygon
            className="st34"
            points="77 380 190.9 380 190.9 391 77 391"
          />
          <polygon
            className="st34"
            points="234 380 347.9 380 347.9 391 234 391"
          />
          <path
            className="st36"
            d="m59 678h416.9c1.1 0 2 0.9 2 2v81.8c0 1.1-0.9 2-2 2h-416.9c-1.1 0-2-0.9-2-2v-81.8c0-1.1 0.9-2 2-2z"
          />
          <polygon
            className="st37"
            points="154 716 382.9 716 382.9 727 154 727"
          />
          <rect className="st34" x="107.5" y="118.4" width="297" height="26" />
        </g>
      </g>
      <g transform="translate(1251 870)">
        <path
          className="st27"
          d="m26.7 8.7c-48.9 26.2-15.8 95.9-15.8 95.9s34.9 57.6 69.8 99.4c34.9 41.9 47.1 97.7 52.3 140.4s1.7 198 43.6 273 122.9 139.1 142.1 177.5l206.8-125.2s-85.5-151.7-106.4-247.7c-20.9-95.9-38.4-200.6-61.1-241.6-22.5-40.9-197-180.4-197-180.4v118.6c-15.7-13.9-106.3-126.6-134.3-109.9z"
        />
        <path
          className="st38"
          d="m336.1 902.3c-22.3-41.2-42.4-83.6-43-93.1-1.7-26.2 208.2-156 226.7-149.9-2.9 13.4 0.5 243 0.5 243s-109.4 0-184.2 0z"
        />
        <path
          className="st28"
          d="m161.3 118.8c0.1 0 45.9 67.5 57.2 89.5 29.5 57.5 84.4 139.8 94.6 149.4 0 0-57.3-98.7-71.6-133.6-8-19.4-69.9-117.1-80.2-116.6v11.3z"
        />
      </g>
    </g>
  </Styling>
);
